import axios from "axios";

export default {
  getEstimation(estimationData) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${process.env.ESTIMATION_SERVICE_PUBLIC_PATH}`,
        data: estimationData
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
}


// WEBPACK FOOTER //
// ./src/services/estimationService.js